<template>
    <aside class="left-sidebar">
        <!-- Sidebar scroll-->
        <div class="scroll-sidebar">              
            <nav class="sidebar-nav">
                <ul id="sidebarnav">
                    <li class="nav-small-cap">{{$t('sideBar.masterAgentMenu')}}</li>
                    
                    <li>
                      <router-link to="/">
                        <a class="waves-effect waves-dark" href="#" style='padding:0;' >
                            <i class="ti ti-dashboard"></i>
                            <span class="hide-menu">{{$t('sideBar.dashboard')}}</span>
                        </a>
                         </router-link>
                    </li>
                    <li class="nav-devider"></li>
                    <li> <a class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false">
                      <i class="ti-location-pin"></i><span class="hide-menu">{{$t('sideBar.locations')}}</span></a>
                      <ul aria-expanded="false" class="collapse">
                        <li><router-link to="/locations">{{$t('sideBar.locations')}}</router-link></li>
                      </ul>
                    </li>

                    <li > 
                      <router-link to="/catalog">
                        <div class="waves-effect waves-dark">
                          <i class="ti ti-mobile"></i><span class="hide-menu">{{$t('sideBar.catalog')}} </span>
                        </div>
                      </router-link>
                    </li>
                     
                    <!-- <li class="nav-devider"></li>
                    <li>
                      <li> <router-link to="/reportCenter"><div class="waves-effect waves-dark"><i class="mdi mdi-chart-line"></i><span class="hide-menu">{{$t('sideBar.reportCenter')}}</span></div></router-link>
                    </li> -->
                    <li class="nav-devider"></li>
                    <li> <a class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false">
                      <i class="mdi mdi-settings"></i><span class="hide-menu">{{$t('sideBar.settings')}}</span></a>
                      <ul aria-expanded="false" class="collapse">
                        <li><router-link to="/setting">{{$t('sideBar.setting')}}</router-link></li>
                        <li><router-link to="/invite/user">{{$t('sideBar.inviteUser')}}</router-link></li>
                        <li><router-link to="/invite/store">{{$t('sideBar.inviteStore')}}</router-link></li>
                      </ul>
                    </li>
                </ul>
            </nav>
            <!-- End Sidebar navigation -->
        </div>
        
    </aside>
</template>

<script>
  export default {
    methods: {
      showBillPayment () {
        this.$modal.show('new-bill-payment', {callFrom: 'itself'})
      },
      setScrollBar () {
        $('.scroll-sidebar').slimScroll({
          position: 'right',
          size: '5px',
          height: '100%',
          color: '#5C6A71'
        })
      },
      testNot () {
        console.log('test in here')
        // $.toast('Here you can put the text of the toast')
      }
    },
    mounted () {
      this.setScrollBar()
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Layout/Sidebar.vue